import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { Observable, Subscription, of } from 'rxjs';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { ReguleringService } from '../regulering.service';

@Component({
  selector: 'app-regulering-popup',
  templateUrl: './regulering-popup.component.html',
  styleUrls: ['./regulering-popup.component.css']
})
export class ReguleringPopupComponent implements OnInit {
 
  combObs$ = new Observable()
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];
  onShowUnit: EventEmitter<ActionButtonEvent>;
  onShowUnitSubscription: Subscription;
  columnSettings: ColumnSetting[] = [
    {
      columnId: 'systemName',
      name: 'Name'
    },
    {
      columnId: 'systemId',
      name: 'system'
    },
    {
      columnId: 'siteId',
      name: 'site'
    },{
      columnId: 'channelId',
      name: 'channel'
    },
    {
      columnId: 'status',
      name: 'Status'
    }
    ]
 
  sortArray = ['Name','Number','Machine','Selection','Required Quantity',"Available Quantity"]
  constructor(
    private regulerinService : ReguleringService,
    public dialogRef: MatDialogRef<ReguleringPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
      console.log(data)
      
     this.combObs$ = this.regulerinService.getReguleringsRefrences(data)
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  genEmail(id){
    console.log(id)
  }
  ngOnInit() {
  }

}
